<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12 ">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex">
          <div class="col-sm-12 col-xs-12">
            <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
              <h3 class="title">SWIFT</h3>
              <h5 class="desc">SWIFT 문서를 등록하고 이력을 관리합니다.</h5>
            </div>
          </div>
        </div>
        <a-row type="flex" align="middle" :gutter=30 justify="center">
          <a-col class="col-sm-12 col-xs-12 contract-container">
            <div class="contract-title">
              {{ pageTitle }} 등록하기
            </div>
            <div class="contract-section-wrap">
              <div class="contract-items-container">
                <input 
                    type="file" 
                    hidden 
                    id="swiftFileInput"
                    ref="swiftFileInput"
                    accept="application/pdf"
                    multiple
                    @change="uploadPdfToServer"
                />
                <contract-item-wrap
                    :width="120"
                    label="Swift"
                    :is-required="true"
                    :class="'fixed-btn-110'"
                >
                <div style="width: 100%; display: flex; flex-direction: column; gap: 10px;">
                  <div 
                    class="file-drop-area"
                    @dragenter.prevent="onDragEnter"
                    @dragover.prevent="onDragOver" 
                    @dragleave.prevent="onDragLeave"
                    @drop.prevent="onDrop"
                    :class="{ 'dragging': isDragging }"
                    @click="onFileInputClick"
                  >
                    <div class="file-drop-area-title">
                      첨부할 파일을 여기에 드래그 해 주세요.
                    </div>
                    <div class="file-drop-area-desc">
                      또는
                    </div>
                    <a-button
                      class="black"
                    >
                      파일 업로드
                    </a-button>
                  </div>
                    <!-- 새로 업로드된 파일 목록 -->
                    <div style="width: 100%; border-bottom: 1px solid #e0e0e0; padding-bottom: 10px;" v-show="swiftData.fileList && swiftData.fileList.length > 0">
                      <div style="width: 100%; display: flex; gap: 5px; align-items: center;">
                        첨부 <span style="color: #1890ff; font-weight: 700;">{{ swiftData.fileList.length }}</span>개
                      </div>
                    </div>
                  <div class="file-list" v-if="swiftData.fileList && swiftData.fileList.length > 0">
                    <div class="file-item" v-for="(file, index) in swiftData.fileList" :key="index">
                      <span class="file-name">{{ file.fileName }}</span>
                      <i class="fa-solid fa-times" @click="removeFile(index)" style="cursor: pointer; color: #ff4d4f;"></i>
                    </div>
                  </div>
                </div>
                  <!-- <div class="disabled-event-wrap">
                    <input
                        id="fileUrl"
                        ref="fileUrl"
                        class="ant-like-input"
                        type="text"
                        disabled
                        v-model="swiftData.fileName"
                        placeholder="SWIFT 파일을 업로드해주세요."
                    />
                    <div class="drag-drop-area">
                      <i class="fa-regular fa-square-plus" />
                      첨부할 파일을 여기에 드래그 해 주세요.
                    </div>
                  </div>
                  <button class="btn-darkgray btn-hover"
                          @click="$refs.swiftFileInput.click">
                    파일 업로드
                  </button> -->
                </contract-item-wrap>
                <contract-item-wrap
                    :width="120"
                    label=""
                    :is-required="false"
                    :class="'divide-two'"
                >
                  <div class="input-area">
                    <a-checkbox  class="is-primary" v-model:checked="swiftData.isAmend" style="width: 100%;">Amend 문서</a-checkbox>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    :width="120"
                    label=""
                    :is-required="false"
                    :class="'divide-two'"
                >
                  <div class="input-area">
                    <div>확장자 : pdf</div>
                    <div>파일 첨부 제한: 개별 파일 최대 5MB, 전체 첨부파일 최대 100MB</div>
                  </div>
                </contract-item-wrap>

                <contract-item-wrap
                    :width="120"
                    label="SWIFT명"
                    :is-required="true"
                    :class="'divide-two'"
                >
                  <div class="input-area">
                    <input
                        class="full-width ant-like-input"
                        type="text"
                        placeholder="SWIFT명을 입력해주세요."
                        ref="name"
                        v-model="swiftData.name"
                        @input="handleRemoveError"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    :width="120"
                    label="보증 종류"
                    :is-required="true"
                    :class="'divide-two'"
                >
                  <div class="input-area">
                    <input
                        class="full-width ant-like-input"
                        type="text"
                        placeholder="보증 종류를 입력해주세요(ex. P, AP, W) "
                        ref="warrantyType"
                        v-model="swiftData.warrantyType"
                        @input="handleRemoveError"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    :width="120"
                    label="Applicant"
                    :is-required="true"
                    :class="'divide-two'"
                >
                  <div class="input-area">
                    <input
                        class="full-width ant-like-input"
                        type="text"
                        placeholder="신청인을 입력해주세요."
                        ref="applicant"
                        v-model="swiftData.applicant"
                        @input="handleRemoveError"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    :width="120"
                    label="발신자(BIC)"
                    :is-required="true"
                    :class="'divide-two'"
                >
                  <div class="input-area">
                    <input
                        class="full-width ant-like-input"
                        type="text"
                        placeholder="발신자의 BIC를 입력해주세요."
                        ref="senderBic"
                        v-model="swiftData.senderBic"
                        @input="handleRemoveError"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    :width="120"
                    label="수신자(BIC)"
                    :is-required="true"
                    :class="'divide-two'"
                >
                  <div class="input-area">
                    <input
                        class="full-width ant-like-input"
                        type="text"
                        placeholder="수신자의 BIC를 입력해주세요."
                        ref="receiverBic"
                        v-model="swiftData.receiverBic"
                        @input="handleRemoveError"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    :width="120"
                    label="Related Ref."
                    :is-required="true"
                    :class="'divide-two'"
                >
                  <div class="input-area">
                    <input
                        class="full-width ant-like-input"
                        type="text"
                        placeholder="관련 참조 번호를 입력해주세요."
                        ref="relatedRef"
                        v-model="swiftData.relatedRef"
                        @input="handleRemoveError"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    :width="120"
                    label="Transaction Ref."
                    :is-required="true"
                    :class="'divide-two'"
                >
                  <div class="input-area">
                    <input
                        class="full-width ant-like-input"
                        type="text"
                        placeholder="거래 참조 번호를 입력해주세요."
                        ref="transactionRef"
                        v-model="swiftData.transactionRef"
                        @input="handleRemoveError"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    :width="120"
                    label="Date of Issue or Amendment"
                    :is-required="true"
                    :class="'divide-two'"
                >
                  <div class="input-area">
                    <a-date-picker :locale="locale" @click="handleRemoveError" id="issueAmendmentAt" ref="issueAmendmentAt" v-model:value="swiftData.issueAmendmentAt" :placeholder="`발행 또는 수정일자를 입력해주세요.`"/>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    :width="120"
                    label="Number of Amendment"
                    :is-required="false"
                    :class="'divide-two'"
                >
                  <div class="input-area">
                    <input
                        class="full-width ant-like-input"
                        type="text"
                        placeholder="수정 건수를 입력해주세요."
                        ref="amendmentNo"
                        v-model="swiftData.amendmentNo"
                        @input="handleRemoveError"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    :width="120"
                    label="Date of Expiry"
                    :is-required="true"
                    :class="'divide-two'"
                >
                  <div class="input-area">
                    <a-date-picker :locale="locale" @click="handleRemoveError" id="expiryAt" ref="expiryAt" v-model:value="swiftData.expiryAt" :placeholder="`만기일을 입력해주세요.`"/>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    :width="120"
                    label="보증금액"
                    :is-required="true"
                    :class="'divide-two'"
                >
                  <div class="input-area">
                    <a-input v-model:value="swiftData.warrantyAmount" @input="(event)=>{this.formatCurrency(event);this.handleRemoveError(event);}" id="warrantyAmount" ref="warrantyAmount" placeholder="보증 금액을 입력해주세요."></a-input>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    :width="120"
                    label="통화"
                    :is-required="true"
                    :class="'divide-two'"
                >
                  <div class="input-area">
                    <a-select 
                        v-model:value="swiftData.currency" 
                        style="width: 200px;"
                    >
                        <a-select-option :value="currentData.value" v-for="currentData in currnecyList">{{currentData.name}} ({{ currentData.value}})</a-select-option>
                    </a-select>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    :width="120"
                    label="비고"
                    :is-required="false"
                    :class="'divide-two'"
                >
                  <div class="input-area">
                    <a-textarea 
                      v-model:value="swiftData.note" 
                      placeholder="비고를 입력해주세요."
                      style="height: 100px;"
                      class="note-area"
                    />
                  </div>
                </contract-item-wrap>
              </div>
            </div>
            <div class="contract-footer">
              <button
                  class="contract-cancel-btn btn-hover"
                  @click="$router.push('/swift/list')"
                >
                취소
              </button>
              <button
                  class="contract-submit-btn btn-hover"
                  style="font-weight: 700;"
                  @click="issueSwift"
                >
                등록
              </button>
            </div>
          </a-col>
          <a-col></a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>
<script>
import {
  oneBtnDialog,
  phoneNumberFormatter,
  formatCommaNumber,
  logging,
  businessNumberFormatter, twoBtnDialog,
} from '@/utils/utils';
import {
  RouterEnum,
} from '@/enums/router.enums';
import ContractItemWrap from '@/views/ContractManagement/components/ContractItemWrap';
import SignModal from '@/views/ContractManagement/components/SignModal';
import SearchClientModal from '@/views/ContractManagement/components/SearchClientModal';
import {localStorageEnums} from "@/enums/localStorage.enums";
import {LottieAnimation} from "lottie-web-vue";
import loadingAnimation from "@/assets/img/loading.json";
import locale from 'ant-design-vue/es/date-picker/locale/ko_KR';
import dayjs from 'dayjs';

export default {
  name: RouterEnum.ContractManagement.Contracts.Dentium.Robot.name,
  components: {
    LottieAnimation,
    ContractItemWrap,
    SignModal,
    SearchClientModal,
  },
  props: {
    templateId: {
      type: String,
      required: true,
    }
  },
  computed: {
    formattedTotalPrice() {
      return formatCommaNumber(this.contractInfo.totalPrice);
    },
  },
  data() {
    return {
      loadingAnimation,
      locale,
      pageTitle: 'SWIFT',
      logging,
      isDragging: false,
      swiftData:{
        fileUrl: "",
        fileName: "",
        isAmend: false,
        name: "",
        warrantyType: "",
        applicant: "",
        senderBic: "PMCFKRSEXXX",
        receiverBic: "",
        relatedRef: "",
        transactionRef: "",
        issueAmendmentAt: '',
        amendmentNo: "",
        expiryAt: "",
        warrantyAmount: '',
        currency: "USD",
        note: "",
        fileList: [], // 추가: 업로드된 파일 목록
      },
      currnecyList:[
        {
          name:'미국 달러',
          value:'USD',
        },
        {
          name:'ADB 통화 단위',
          value:'XUA',
        },
        {
          name:'CFA 프랑 BCEAO',
          value:'XOF',
        },
        {
          name:'CFA 프랑 BEAC',
          value:'XAF',
        },
        {
          name:'CFP 프랑',
          value:'XPF',
        },
        {
          name:'Mvdol',
          value:'BOV',
        },
        {
          name:'SDR (특별인출권)',
          value:'XDR',
        },
        {
          name:'UAE 디르함',
          value:'AED',
        },
        {
          name:'WIR 유로',
          value:'CHE',
        },
        {
          name:'WIR 프랑',
          value:'CHW',
        },
        {
          name:'가나 세디',
          value:'GHS',
        },
        {
          name:'가이아나 달러',
          value:'GYD',
        },
        {
          name:'과라니',
          value:'PYG',
        },
        {
          name:'기니프랑',
          value:'GNF',
        },
        {
          name:'께찰',
          value:'GTQ',
        },
        {
          name:'나미비아 달러',
          value:'NAD',
        },
        {
          name:'나이라',
          value:'NGN',
        },
        {
          name:'낙파',
          value:'ERN',
        },
        {
          name:'남수단 파운드',
          value:'SSP',
        },
        {
          name:'네덜란드령 안틸레스 휠던',
          value:'ANG',
        },
        {
          name:'네팔 루피',
          value:'NPR',
        },
        {
          name:'노르웨이 크로네',
          value:'NOK',
        },
        {
          name:'누에보솔',
          value:'PEN',
        },
        {
          name:'눌트럼',
          value:'BTN',
        },
        {
          name:'뉴질랜드 달러',
          value:'NZD',
        },
        {
          name:'니카라과 코르도바',
          value:'NIO',
        },
        {
          name:'달라시',
          value:'GMD',
        },
        {
          name:'데나르',
          value:'MKD',
        },
        {
          name:'덴마크 크로네',
          value:'DKK',
        },
        {
          name:'도미니카 페소',
          value:'DOP',
        },
        {
          name:'도브라',
          value:'STN',
        },
        {
          name:'동카리브 달러',
          value:'XCD',
        },
        {
          name:'둥',
          value:'VND',
        },
        {
          name:'라리',
          value:'GEL',
        },
        {
          name:'라이베리아 달러',
          value:'LRD',
        },
        {
          name:'랜드',
          value:'ZAR',
        },
        {
          name:'러시아 루블',
          value:'RUB',
        },
        {
          name:'레바논 파운드',
          value:'LBP',
        },
        {
          name:'렉',
          value:'ALL',
        },
        {
          name:'렘피라',
          value:'HNL',
        },
        {
          name:'로티',
          value:'LSL',
        },
        {
          name:'루마니아 레우',
          value:'RON',
        },
        {
          name:'루피아',
          value:'IDR',
        },
        {
          name:'루피야',
          value:'MVR',
        },
        {
          name:'르완다 프랑',
          value:'RWF',
        },
        {
          name:'리랑게니',
          value:'SZL',
        },
        {
          name:'리비아디나르',
          value:'LYD',
        },
        {
          name:'리알 오마니',
          value:'OMR',
        },
        {
          name:'리엘',
          value:'KHR',
        },
        {
          name:'리온',
          value:'SLL',
        },
        {
          name:'마다가스카르 아리아리',
          value:'MGA',
        },
        {
          name:'말레이시아 링기트',
          value:'MYR',
        },
        {
          name:'멕시코 투자 단위(UDI)',
          value:'MXV',
        },
        {
          name:'멕시코 페소',
          value:'MXN',
        },
        {
          name:'모로코 화폐',
          value:'MAD',
        },
        {
          name:'모리셔스 루피',
          value:'MUR',
        },
        {
          name:'모잠비크 메티칼',
          value:'MZN',
        },
        {
          name:'몰도바레우',
          value:'MDL',
        },
        {
          name:'미국 달러 (익일)',
          value:'USN',
        },
        {
          name:'바레인 디나르',
          value:'BHD',
        },
        {
          name:'바베이도스 달러',
          value:'BBD',
        },
        {
          name:'바투',
          value:'VUV',
        },
        {
          name:'바트',
          value:'THB',
        },
        {
          name:'바하마 달러',
          value:'BSD',
        },
        {
          name:'발보아',
          value:'PAB',
        },
        {
          name:'버뮤다 달러',
          value:'BMD',
        },
        {
          name:'범용 통화 없음',
          value:'',
        },
        {
          name:'벨로루시 루블',
          value:'BYR',
        },
        {
          name:'벨리즈 달러',
          value:'BZD',
        },
        {
          name:'볼리바',
          value:'VEF',
        },
        {
          name:'볼리비아노',
          value:'BOB',
        },
        {
          name:'부룬디프랑',
          value:'BIF',
        },
        {
          name:'북한 원',
          value:'KPW',
        },
        {
          name:'불가리아 레프',
          value:'BGN',
        },
        {
          name:'브라질 레알',
          value:'BRL',
        },
        {
          name:'브루나이 달러',
          value:'BND',
        },
        {
          name:'사우디아라비아 리얄',
          value:'SAR',
        },
        {
          name:'세르비아 디나르',
          value:'RSD',
        },
        {
          name:'세이셸 루페',
          value:'SCR',
        },
        {
          name:'세인트 헬레나 파운드',
          value:'SHP',
        },
        {
          name:'셰켈',
          value:'ILS',
        },
        {
          name:'소말리아 실링',
          value:'SOS',
        },
        {
          name:'소모니',
          value:'TJS',
        },
        {
          name:'솔로몬제도 화폐단위 달러',
          value:'SBD',
        },
        {
          name:'솜',
          value:'KGS',
        },
        {
          name:'수단 파운드',
          value:'SDG',
        },
        {
          name:'수리남 달러',
          value:'SRD',
        },
        {
          name:'수크레',
          value:'XSU',
        },
        {
          name:'스리랑카 화폐단위 루피',
          value:'LKR',
        },
        {
          name:'스웨덴 크로나',
          value:'SEK',
        },
        {
          name:'스위스 프랑',
          value:'CHF',
        },
        {
          name:'시리아 파운드',
          value:'SYP',
        },
        {
          name:'신타이비',
          value:'TWD',
        },
        {
          name:'싱가포르 달러',
          value:'SGD',
        },
        {
          name:'아루바 플로린',
          value:'AWG',
        },
        {
          name:'아르메니아 드람',
          value:'AMD',
        },
        {
          name:'아르헨티나 페소',
          value:'ARS',
        },
        {
          name:'아이슬란드 크로나',
          value:'ISK',
        },
        {
          name:'아제르바이잔 마나트',
          value:'AZN',
        },
        {
          name:'아프가니',
          value:'AFN',
        },
        {
          name:'알제리 디나르',
          value:'DZD',
        },
        {
          name:'에티오피아 비르',
          value:'ETB',
        },
        {
          name:'엔',
          value:'JPY',
        },
        {
          name:'엘살바도르 콜론',
          value:'SVC',
        },
        {
          name:'예멘리알',
          value:'YER',
        },
        {
          name:'오스트레일리아 달러',
          value:'AUD',
        },
        {
          name:'요르단 디나르',
          value:'JOD',
        },
        {
          name:'우간다 실링',
          value:'UGX',
        },
        {
          name:'우기니',
          value:'MRU',
        },
        {
          name:'우니다드 데 포멘토',
          value:'CLF',
        },
        {
          name:'우루과이 페소(URUIURUI)',
          value:'UYI',
        },
        {
          name:'우주베키스탄 숨',
          value:'UZS',
        },
        {
          name:'원',
          value:'KRW',
        },
        {
          name:'유니다드 드 발로르 레알',
          value:'COU',
        },
        {
          name:'유로',
          value:'EUR',
        },
        {
          name:'유안화폐',
          value:'CNY',
        },
        {
          name:'은화',
          value:'HTG',
        },
        {
          name:'이라크 디나르',
          value:'IQD',
        },
        {
          name:'이란 리알',
          value:'IRR',
        },
        {
          name:'이집트 파운드',
          value:'EGP',
        },
        {
          name:'인도 루피',
          value:'INR',
        },
        {
          name:'자메이카 달러',
          value:'JMD',
        },
        {
          name:'잠비아 크와차',
          value:'ZMW',
        },
        {
          name:'즐로티',
          value:'PLN',
        },
        {
          name:'지부티 프랑',
          value:'DJF',
        },
        {
          name:'지브롤터 파운드',
          value:'GIP',
        },
        {
          name:'짐바브웨 달러',
          value:'ZWL',
        },
        {
          name:'차트',
          value:'MMK',
        },
        {
          name:'체코 코루나',
          value:'CZK',
        },
        {
          name:'칠레 페소',
          value:'CLP',
        },
        {
          name:'카보베르데 에스쿠도',
          value:'CVE',
        },
        {
          name:'카타르 리알',
          value:'QAR',
        },
        {
          name:'캐나다 달러',
          value:'CAD',
        },
        {
          name:'컨버터블 마르크',
          value:'BAM',
        },
        {
          name:'케냐 실링',
          value:'KES',
        },
        {
          name:'케이맨제도 달러',
          value:'KYD',
        },
        {
          name:'코모로 프랑',
          value:'KMF',
        },
        {
          name:'코스타리카 콜론',
          value:'CRC',
        },
        {
          name:'콜롬비아 페소',
          value:'COP',
        },
        {
          name:'콩고 프랑',
          value:'CDF',
        },
        {
          name:'콴자',
          value:'AOA',
        },
        {
          name:'쿠나',
          value:'HRK',
        },
        {
          name:'쿠바 페소',
          value:'CUP',
        },
        {
          name:'쿠웨이트 디나르',
          value:'KWD',
        },
        {
          name:'크와차',
          value:'MWK',
        },
        {
          name:'키나',
          value:'PGK',
        },
        {
          name:'킵',
          value:'LAK',
        },
        {
          name:'타카',
          value:'BDT',
        },
        {
          name:'탄자니아 실링',
          value:'TZS',
        },
        {
          name:'탈라',
          value:'WST',
        },
        {
          name:'태환페소',
          value:'CUC',
        },
        {
          name:'터키 리라',
          value:'TRY',
        },
        {
          name:'텡게',
          value:'KZT',
        },
        {
          name:'통가 파앙가',
          value:'TOP',
        },
        {
          name:'투그리크',
          value:'MNT',
        },
        {
          name:'투르크메니스탄 뉴 마나트',
          value:'TMT',
        },
        {
          name:'튀니지 디나르',
          value:'TND',
        },
        {
          name:'트리니다드토바고 달러',
          value:'TTD',
        },
        {
          name:'파운드스털링',
          value:'GBP',
        },
        {
          name:'파키스탄 루피',
          value:'PKR',
        },
        {
          name:'파타카',
          value:'MOP',
        },
        {
          name:'페소 우루과요',
          value:'UYU',
        },
        {
          name:'포린트',
          value:'HUF',
        },
        {
          name:'포클랜드 제도 파운드',
          value:'FKP',
        },
        {
          name:'풀라',
          value:'BWP',
        },
        {
          name:'피지 달러',
          value:'FJD',
        },
        {
          name:'필리핀 페소',
          value:'PHP',
        },
        {
          name:'홍콩 달러',
          value:'HKD',
        },
        {
          name:'흐리브냐',
          value:'UAH',
        },
      ]
    }
  },
  async mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    twoBtnDialog,
    findAncestor (el, sel) {
      while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,sel)));
      return el;
    },
    onDragEnter(e) {
      e.preventDefault();
      this.isDragging = true;
    },

    onDragOver(e) {
      e.preventDefault(); 
      this.isDragging = true;
    },

    onDragLeave(e) {
      e.preventDefault();
      this.isDragging = false;
    },
    async onDrop(e) {
      e.preventDefault(); // 브라우저 기본 동작 방지
      this.isDragging = false;
      
      const files = e.dataTransfer.files;
      
      if (files.length > 0) {
        // 단순 파일 업로드를 위해 uploadPdfToServer 메서드 호출
        await this.uploadPdfToServer({ target: { files: files }});
      }
    },
    onFileInputClick() {
      this.$refs.swiftFileInput.click();
    },
    async issueSwift(){
        try {
          const isRequiredFilled = await this.validateRequiredValues();
          if (!isRequiredFilled) {
            await oneBtnDialog('필수값 누락', '필수값을 모두 입력해 주세요.', false);
            return false;
          }
          const obj = {
            ...this.swiftData,
            isAmend: this.swiftData.isAmend === true ? 'Y' : 'N',
            warrantyAmount: parseFloat(this.swiftData.warrantyAmount.replace(/,/g, '')),
            issueAmendmentAt: this.swiftData.issueAmendmentAt.format('YYYY/MM/DD'),
            expiryAt: this.swiftData.expiryAt.format('YYYY/MM/DD'),
            fileList: this.swiftData.fileList, // 파일 목록 추가
          };
          delete obj.fileName

          this.$store.commit('setIsLoading', true);
          const response = await this.$apiInstance.post(`/swift/request`,obj);
          console.log(response);
          this.$store.commit('setIsLoading', false);
          if((response.status !== 200 && response.status !== 201)){
            await oneBtnDialog('등록 실패', '문서가 등록에 실패했습니다.', false);  
          }else{
            await oneBtnDialog('등록 성공', '문서가 성공적으로 등록되었습니다.', false);
            this.$router.push('/swift/list');
          }
        } catch(error) {
          this.$store.commit('setIsLoading', false);
          console.log(error);
          await oneBtnDialog('등록 실패', '문서가 등록에 실패했습니다.', false);  
        }
    },
    handleRemoveError(event){
      console.log(event)
      if(event.srcElement){
        event.srcElement.classList.remove('error');
        let contractItemWrap = this.findAncestor(event.srcElement, '.contract-item-wrap');
        if(contractItemWrap){ // //ref의 상위요소에 contractitemwrap 클래스가 있으면 에러 메세지 제거
            contractItemWrap.querySelector('.error-message-wrap').innerHTML = ``;
        }
      }
    },
    async validateRequiredValues(){
      if(this.swiftData.fileList.length === 0) {
        await oneBtnDialog('파일 미첨부', 'PDF 파일을 첨부해주세요.', false);
      }
      
      let result = true;
      Object.entries(this.$refs).forEach(([key, ref]) => {
        if (ref && ref.classList && ref.classList.contains('error')) {
          ref.classList.remove('error');
        }
        let contractItemWrap = this.findAncestor(ref, '.contract-item-wrap');
        if(!contractItemWrap && !document.getElementById(key)){ //ref의 상위요소에 contractitemwrap 클래스가 있으면 종료
          return false;
        }else if(!contractItemWrap){ //ref의 상위요소에 contractitemwrap 클래스가 없다고 나올땐 id로 다시 재탐색 (ant design 입력폼등)
          ref = document.getElementById(key);
          contractItemWrap = this.findAncestor(ref, '.contract-item-wrap');
        }
        if(contractItemWrap){ // ref의 상위요소에 contractitemwrap 클래스가 있으면.
          let isRequired = contractItemWrap.querySelector('label .required-span') ? true:false;
          if(isRequired){
            if(ref.value == ''){ //ref의 값이 빈값이면
              result = false;
              if(this.findAncestor(ref, '.ant-picker')){
                this.findAncestor(ref, '.ant-picker').classList.add('error');
              }else{
                ref.classList.add('error');
              }
              let labelText = contractItemWrap.querySelector('label').innerText;
              contractItemWrap.querySelector('.error-message-wrap').innerHTML = 
              ref.placeholder?
              `<div style="color:red; font-size:13px;">${ref.placeholder}</div>`:
              `<div style="color:red; font-size:13px;">${labelText}를 입력해주세요.</div>`;
            }
          }
        }
      });

      return result;
    },
    formatCurrency(event){
      let value = event.target.value;
      if(value == ''){
        return false;
      }
      
      // 숫자와 소수점만 허용하는 정규식으로 변경
      value = value.replace(/[^\d.]/g, '');
      
      // 소수점이 여러 개 입력된 경우 첫 번째 소수점만 유지
      let parts = value.split('.');
      if (parts.length > 2) {
        parts = [parts[0], parts.slice(1).join('')];
      }
      
      let integerPart = parts[0];
      let decimalPart = parts[1] || '';

      // 정수 부분에 천단위 콤마 적용
      integerPart = integerPart ? new Intl.NumberFormat().format(parseInt(integerPart)) : '0';

      // 소수점 둘째자리까지만 허용
      if(decimalPart) {
        decimalPart = decimalPart.slice(0, 2);
        this.swiftData.warrantyAmount = `${integerPart}.${decimalPart}`;
      } else {
        // 입력값이 소수점으로 끝나는 경우 소수점 유지
        this.swiftData.warrantyAmount = value.endsWith('.') ? `${integerPart}.` : integerPart;
      }
    },
    // 임시 파일명 생성 함수
    generateTempFileName(originalFile) {
      const timestamp = Date.now();
      const random = Math.floor(Math.random() * 1000);
      const extension = originalFile.name.split('.').pop();
      return `temp_document_${timestamp}_${random}.${extension}`;
    },

    // PDF 파일 업로드 메서드
    async uploadPdfToServer(event){
      try {
        const fileInput = document.getElementById('swiftFileInput');
        if (!event.target.files || event.target.files.length === 0) {
          return false;
        }
        
        this.$store.commit('setIsLoading', true);
        
        for (const file of event.target.files) {
          if(file.type != 'application/pdf'){
            this.$store.commit('setIsLoading', false);
            await oneBtnDialog('알림', 'PDF 파일만 업로드 가능합니다.', false);
            return false;
          }
      
          // 파일 크기 확인 (5MB)
          const maxFileSize = 5 * 1024 * 1024;
          if(file.size > maxFileSize){
            this.$store.commit('setIsLoading', false);
            const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
            await oneBtnDialog('업로드 실패', `첨부가능한 최대 용량은 5MB입니다. (${fileSizeMB}MB)`, false);
            return false;
          }
          
          // 한글 파일명 문제 해결을 위해 임시 파일명 사용
          const formData = new FormData();
          const tempFileName = this.generateTempFileName(file);
          const tempFile = new File([file], tempFileName, { type: file.type });
          formData.append('file', tempFile);

          const response = await this.$apiInstance.post(`/object-storages`, formData);
          console.log(response.data);
          if (response.status !== 200 && response.status !== 201) {
            this.$store.commit('setIsLoading', false);
            await oneBtnDialog('알림', `${file.name} 파일 업로드에 실패했습니다.`, false);
            continue;
          }
          
          // 파일 목록에 원본 파일명으로 저장
          this.swiftData.fileList.push({ 
            fileName: file.name, // 원본 파일명 사용
            url: response.data.url 
          });
          console.log(`${file.name} 업로드 성공:`, response);
        }
        
        fileInput.value = '';
        this.$store.commit('setIsLoading', false);
      } catch(error) {
        console.log(error);
        this.$store.commit('setIsLoading', false);
        await oneBtnDialog('PDF 파일 업로드 실패', 'PDF 파일 업로드에 실패했습니다.', false);
      }  
    },
    removeFile(index) {
      this.swiftData.fileList.splice(index, 1);
    }
  }
}
</script>
<style scoped>
.titleContainer {
  margin-bottom: 30px;

  .title {
    font-size: 24px;
    font-weight: bold;
    color: #2F3337;
    line-height: 1.2;
    margin-bottom: 5px;
    letter-spacing: 0;
  }

  .desc {
    color: #6e747c;
    font-weight: 400;
  }
}

.productRemark {
  text-align: left;
  width: 100%;
  height: 120px;
  border-radius: 8px;
  border: 1px #ced4da solid;
  resize: none;
  padding: 10px;
}

.productRemark::placeholder {
  color: #8D939A;
  font-size: 16px;
}
</style>
<style scoped lang="scss">
@import '@/assets/scss/contract-detail.scss';

.ant-select {

  .ant-select-selector {
    .ant-select-selection-placeholder {
      color: #8D939A !important;
    }

    &:hover {
      border: none !important;
      border: 2px solid #0946c0 !important;
    }

    &:focus {
      border: 2px solid #0946c0 !important;
    }
  }
}

</style>
<style lang="scss">
.ant-checkbox-wrapper.is-primary .ant-checkbox-checked{
  &:after{
    border-color: #1677ff !important;
  }
  .ant-checkbox-inner {
    background-color: #1677ff !important;
    border-color: #1677ff !important;
  }
}
</style>
<style lang="scss" scoped>
.note-area {
  height: 100px;
  resize: none;
}

.file-drop-area {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding: 30px 10px;
  border: 1px solid #D1D6DB;
  gap: 8px;
  justify-content: center;
  align-items: center;
  color: #2F3337;
  transition: ease-in-out 0.2s;

  .file-drop-area-title {
    font-size: 16px;
    font-weight: 700;
  }

  .file-drop-area-desc {
    font-size: 14px;
  }

  &:hover {
    background-color: #F1F2F3;
    transition: ease-in-out 0.2s;
    cursor: pointer;
  }

}

.file-drop-area.dragging {
  background-color: #F1F2F3;
  transition: ease-in-out 0.2s;
  cursor: grabbing;
}

.file-list {
  width: 100%;
  margin-top: 10px;
  
  .file-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    margin-bottom: 5px;
    
    .file-name {
      font-size: 14px;
      color: #495057;
      flex: 1;
      margin-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    
    i {
      font-size: 14px;
      padding: 2px;
      
      &:hover {
        color: #dc3545 !important;
      }
    }
  }
}



.disabled-event-wrap {
  position: relative;
  .drag-drop-area {
    position: absolute;
    top: 40px;
    left: 0;
    width: 100%;
    height: 100px;
    background-color: #f0f0f0;
    z-index: 2;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #6e747c;
    i {
      font-size: 32px;
    }
  }
}
</style>